<template>
    <div class="lg:hidden text-sm mt-2 ml-2 space-y-1">
        <slot />
    </div>
</template>

<script setup>
defineOptions({
    name: 'ZenGridMobileDetail',
})
</script>
